import { getDeviceType, DEVICES } from './device';
import { isRelogin } from './open.helpers';
import { isLoggedInCloser } from './auth';
import Logger from './logger';

const ACTIONS = {
    NONE: 'NONE',
    CLEAR: 'CLEAR',
    OPEN: 'OPEN'
};

const getAction = ({
    genesysConfig,
    isRelogin,
    lastMessageTimestamp,
    isCloserOpen,
    isCloserLoggedIn,
    userStatus,
    device
}) => {
    if (!isCloserOpen && !isRelogin && !genesysConfig) {
        return { action: ACTIONS.NONE };
    }

    if (!isRelogin && !lastMessageTimestamp) {
        return { action: ACTIONS.CLEAR };
    }

    const getReloadParams = () => {
        return `o=${isCloserOpen ? '1' : '0'},r=${isRelogin ? '1' : '0'},g=${
            genesysConfig ? '1' : '0'
        }`;
    };

    const reloadParams = getReloadParams();
    switch (userStatus) {
        case 'loggedOut':
            return { action: ACTIONS.CLEAR };
        case 'loggedIn':
            if (device === DEVICES.DESKTOP) {
                if (isRelogin) {
                    return {
                        action: ACTIONS.OPEN,
                        payload: {
                            contactProcessType: 'Support',
                            loginType: 'full',
                            pageReload: true,
                            reloadParams: reloadParams
                        }
                    };
                } else if (isCloserLoggedIn || userStatus === 'loggedIn') {
                    return {
                        action: ACTIONS.OPEN,
                        payload: {
                            loginType: 'full',
                            pageReload: true,
                            genesysConfig: genesysConfig,
                            reloadParams: reloadParams
                        }
                    };
                }
            }
            break;
        case 'annonymous':
            if (device === DEVICES.DESKTOP) {
                return {
                    action: ACTIONS.OPEN,
                    payload: {
                        loginType: 'none',
                        pageReload: true,
                        genesysConfig: genesysConfig,
                        reloadReason: reloadParams
                    }
                };
            }
            break;
        case null:
        default:
            break;
    }
    return { action: ACTIONS.NONE };
};

const performAction = ({ action, payload }) => {
    Logger.log(`reload action=${action}`);
    switch (action) {
        case ACTIONS.NONE:
            break;
        case ACTIONS.CLEAR:
            window.WC._localStorage.clearAll();
            window.WC._sessionStorage.clearAll();
            window.WC.Closer.close('logged out');
            break;
        case ACTIONS.OPEN:
            window.WC.Closer.open(payload);
            break;
        default:
            break;
    }
};

const reload = () => {
    const action = getAction({
        genesysConfig: window.WC._sessionStorage.get('genesysConfig'),
        isRelogin: isRelogin(window.WC._localStorage.get('reloginRequestTimestamp', 'wc.relogin')),
        lastMessageTimestamp: window.WC._localStorage.get('lastActivityTS'),
        isCloserOpen: window.WC.Closer.isOpen(),
        isCloserLoggedIn: isLoggedInCloser(),
        userStatus: window.WC._localStorage.get('userStatus'),
        device: getDeviceType()
    });
    performAction(action);
};

export { getAction, performAction, reload };
